<!--
  //app/components/Shared/icons/ChevronLeftIcon.vue
  -->

<script setup lang="ts">
type Props = {
  width?: number | string;
  height?: number | string;
  customClass?: string;
};

withDefaults(defineProps<Props>(), {
  height: 14,
  width: 14,
});
</script>

<template>
  <svg
    :width="width"
    :height="height"
    :class="customClass"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 20 20"
    fill="none"
  >
    <path
      d="M14 9.98525C13.9999 10.3035 13.8772 10.6087 13.6589 10.8337L9.00174 15.6337C8.89434 15.7483 8.76586 15.8397 8.62382 15.9026C8.48177 15.9655 8.32899 15.9986 8.1744 16C8.01981 16.0013 7.86649 15.971 7.72341 15.9106C7.58032 15.8503 7.45033 15.7612 7.34101 15.6485C7.23169 15.5359 7.14524 15.4019 7.0867 15.2544C7.02816 15.1069 6.9987 14.9489 7.00004 14.7896C7.00139 14.6302 7.03351 14.4728 7.09452 14.3264C7.15554 14.18 7.24424 14.0476 7.35544 13.9369L11.1894 9.98525L7.35544 6.03365C7.14336 5.80733 7.02601 5.50421 7.02866 5.18957C7.03131 4.87494 7.15376 4.57396 7.36962 4.35147C7.58549 4.12898 7.87751 4.00278 8.18278 4.00005C8.48805 3.99731 8.78215 4.11826 9.00174 4.33685L13.6589 9.13685C13.8772 9.36185 13.9999 9.66702 14 9.98525Z"
      fill="currentColor"
      transform="scale(-1, 1) translate(-16, 0)"
    />
  </svg>
</template>

<style scoped></style>
